module.exports = __webpack_public_path__ + "img/ej-03.3b2f2917.svg";